import type {
  BusinessHours,
  DefaultRoles,
  ServiceCatalog,
} from '../tenant-config.js';
import {
  petServicesBusinessHours,
  petServicesDefaultRoles,
  petServicesServiceCatalog,
} from './pet-services.js';

export type VerticalDefaults = {
  serviceCatalog: ServiceCatalog;
  defaultRoles: DefaultRoles;
  businessHours: BusinessHours;
};

const emptyDefaults: VerticalDefaults = {
  serviceCatalog: [],
  defaultRoles: [],
  businessHours: { schedule: {}, holidays: [] },
};

const verticalRegistry: Record<string, VerticalDefaults> = {
  'pet-services': {
    serviceCatalog: petServicesServiceCatalog,
    defaultRoles: petServicesDefaultRoles,
    businessHours: petServicesBusinessHours,
  },
};

export const getDefaultsForVertical = (vertical: string): VerticalDefaults =>
  verticalRegistry[vertical] ?? emptyDefaults;

export {
  petServicesBusinessHours,
  petServicesDefaultRoles,
  petServicesServiceCatalog,
} from './pet-services.js';
